import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.URL + 'franchises',
  GRAPHQL_URL: API.GRAPHQL_URL,
  fetch (franchise_id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}franchises/${franchise_id}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  create (franchise) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}franchises`, franchise)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  update (franchiseId, franchise) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}franchises/${franchiseId}`, franchise)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  delete (franchise_id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}franchise-delete/${franchise_id}`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fetchAll (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}franchises`, {params: payload})
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fetchFranchises () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}franchises`)
        .then(response => { resolve(response.data.data) })
        .catch(error => { reject(error) })
    })
  }
}
